import React, { useState, useContext } from 'react';
import { Modal, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { Button } from '@/shared/components/Button';
import { BiError } from 'react-icons/bi';
import { BsCheck2All } from 'react-icons/bs';
import VoucherPDF from '../../../PDF/Voucher';
import AddAmount from './AddAmount';
import { AuthContext } from '../../../../../context/AuthContext';


const ConfirmCard = ({
 bookingData, paxDetailsHandler, setPaxDetailsHandler, setRefresh, 
}) => {
  const { apiGlobal, userid } = useContext(AuthContext);
  const [bookingID, setBookingId] = useState('');
  const [showvoucherModal, setShowVoucherModal] = useState(false);
  const [AddAmountData, setAddAmountModal] = useState({
    resid: '',
    bookingid: '',
    amount: '',
    modalShow: false,
  });
  if (!bookingData) {
    return <div>Booking Data Not Passed</div>; // Display error message
  }
// Helper function for meal timing
const getMealTiming = (mealOffered) => {
  const timings = {
    1: 'Breakfast',
    2: 'Snacks',
    3: 'Lunch',
    4: 'Dinner',
  };
  return timings[mealOffered] || 'Unknown';
};

const formatDate = (dateString) => {
  if (!dateString) return ''; // Handle empty values
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};

const getStatusMessage = (status) => {
  if (status === '1') return 'Awaiting approval from restaurant';
  if (status === '2') return 'Payment Pending';
  if (status === '3') return 'Payment Pending';
  if (status === '4') return 'Confirmed';
  return 'Pending Approval';
};
const generateVoucherPdf = (bookingid) => {
  setBookingId(bookingid);
  setShowVoucherModal(true);
};

const handleRestaurnatPayment = async (value) => {
        // console.log(JSON.stringify(value, null, 2));

     if (!AddAmountData.resid || !AddAmountData.bookingid) {
      toast.error('Please select a restaurant and booking ID.');
      return;
     }
     const formData = new FormData();
    formData.append('user_id', userid);
    formData.append('restaurant_id', AddAmountData.resid);
    formData.append('booking_id', AddAmountData.bookingid);
    formData.append('amount', AddAmountData.amount || '');
     
    if (['1', '3', '5'].includes(value.selectPaymentType.value)) {
      formData.append('narration', value.narration || '');
    }
      
    formData.append('payment_type', value.selectPaymentType.value);
      
    if (['1', '3', '5'].includes(value.selectPaymentType.value)) {
      formData.append('payment_date', value.receivedDate);
    }
       
    if (value.selectPaymentType.value === '3') {
      if (!value.ref) {
        toast.error('Please enter Ref No');
        return;
      }
      if (!value.bankName) {
        toast.error('Please enter Bank Name');
        return;
      }
      formData.append('ref_no', value.ref);
      formData.append('bank', value.bankName);
    } else if (value.selectPaymentType.value === '5') {
      if (!value.ref) {
        toast.error('Please enter Cheque Ref No');
        return;
      }
      if (!value.bankName) {
        toast.error('Please enter Bank Name');
        return;
      }
      formData.append('ref_no', value.ref);
      formData.append('bank', value.bankName);
      formData.append('ref_date', value.chequeDate);
    }

   // eslint-disable-next-line 
      // for (const [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
    

 

    try {
      const url = await fetch(`${apiGlobal}/payment_receipt.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
      if (response.status && response.message === 'Success') {
        toast.success('Payment Done....');
        setAddAmountModal({
          resid: '',
          bookingid: '',
          amount: '',
          modalShow: false,
        });
        setRefresh(prev => !prev);
      } else {
        console.error('Something went Wrong while doing payment...');
      }
    } catch (e) {
      console.error(e);
    }

      // Call the API to add amount here
};


  return (
    <div className="card mb-4 shadow-sm" style={{ maxWidth: '100%', borderColor: 'black' }}>
     
      <div className="card-body">
        {/* Header Section */}
        <div className="row mb-3">
          <div className="col-md-12">
            <h5 className="fw-bold">{bookingData.name}</h5>
          </div>
        </div>

        {/* Trip Info */}
        <div className="row mb-4">
          <div className="col-md-4" style={{ display: 'flex' }}>
            <h4 className="fw-bold d-flex">
              Trip: <p>{bookingData.name} - {bookingData.trip_uin}</p>
            </h4>
          </div>
          <div className="col-md-4" style={{ display: 'flex' }}>
            <p className="mb-1">
              <strong>Start Date:</strong> {bookingData.start_date ? formatDate(bookingData.start_date) : ''}
            </p>
            <p style={{ marginLeft: '12px' }}>
              <strong>End Date:</strong> {bookingData.end_date ? formatDate(bookingData.end_date) : ''}
            </p>
          </div>
          <div className="col-md-4 text-end">
            {/* <Button variant="outline-success" size="sm" className="mx-1" title="Edit">
              Email
            </Button>
            <Button variant="outline-warning" size="sm" className="mx-1" title="Edit">
              Edit Trip
            </Button>
            <Button variant="outline-primary" size="sm" className="mx-1" title="Add">
              Add Meal
            </Button> */}
          </div>
        </div>

        {/* Booking Details */}
        {bookingData.booking_details
          && [...bookingData.booking_details]
            .sort((a, b) => (a.status === '0' ? -1 : 1)) // Sort meals with status '0' first
            .map(meal => (
              <div className="card mb-4 shadow-sm" key={meal.id} style={{ maxWidth: '100%' }}>
                <div className="card-body">
                  {/* Meal Day Header */}
                  {/* {meal.pay_flag === 0 && (
                  <span style={{ color: 'red', fontSize: '14px' }}>
                    Restaurant Payment Pending
                  </span>
      )} */}
                  <div className="row mb-2 align-items-center" style={{ display: 'flex' }}>
                    <div className="col-md-8 d-flex align-items-center">
                      <h6 className="me-2">
                        {meal.day_name} - {meal.booking_date ? formatDate(meal.booking_date) : ''}{' '}
                        
                      </h6>
                      {/* <Button variant="outline-success" size="sm" className="mx-1" title="Email">
                        Email
                      </Button>
                      <Button variant="outline-danger" size="sm" className="mx-1" title="Print">
                        Print
                      </Button> */}
                      <Button 
                        variant="outline-danger" 
                        size="sm" 
                        className="mx-1" 
                        title="Print"
                        onClick={() => generateVoucherPdf(meal.id)}
                      >
                        Print
                      </Button>
                      {meal.pay_flag === 0 && (
                      <Button 
                        variant="outline-success" 
                        size="sm" 
                        className="mx-1" 
                        title="Payment for restaurant"
                        onClick={() => setAddAmountModal({
                        resid: meal.restaurant_id,
                        bookingid: meal.id,
                        amount: meal.balance,
                        modalShow: true,
                      })}
                      >
                        Payment to restaurant
                      </Button>
                      )}
                     
                    </div>
                    <div>
                      <p
                        style={{
                          backgroundColor: meal.pay_flag === 0 ? 'red' : 'green',
                           color: 'white',
                            padding: '5px',
                            borderRadius: '50px', 
                            width: 'fit-content',
                           
                          }}
                      >
                        {meal.pay_flag === 0 
                        
                         ? (
                           <>
                             <BiError /> Restaurant Payment Pending
                           </>
) : (
  <>
    <BsCheck2All />Payment Paid to Restaurant
  </>
)}
                      </p>
                    </div>
                   
                  </div>

                  {/* Meal Details */}
                  <div className="row border p-3 rounded">
                    <div className="col-md-3">
                      <p><strong>{meal.meal_name} / {meal.restaurant_name}</strong></p>
                      <p className="text-muted">Locations: {meal.location}</p>
                    </div>
                    <div className="col-md-3">
                      <p><strong>Timing:</strong> {getMealTiming(meal.meal_offered)}</p>
                      <p><strong>Total Meals:</strong> {meal.total_meal}</p>
                    </div>
                    <div className="col-md-3">
                      <p><strong>Type:</strong>   {{
                  1: 'Fit',
                  2: 'Git',
                  3: 'Delivery',
                  // 4: 'Dinner',
                }[meal?.meal_format] || 'Unknown'}
                      </p>
                      <p><strong>Format:</strong> {meal?.meal_type}</p>
                    </div>
                    <div className="col-md-3">
                      <p><strong>Amount:</strong> AED {meal.total_amount}</p>
                      <p>
                        <strong>Status:</strong>{' '}
                        <span 
                          style={{
    color: 'green',
  }}
                        >
                          {/* {getStatusMessage(meal.status)} */}
                          confirmed
                        </span>

                      </p>
                    </div>
                    
                  </div>
                 
                </div>
               
              </div>
            ))}
      </div>
      <Modal
        show={showvoucherModal}
        onHide={() => setShowVoucherModal(false)}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Booking Voucher</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VoucherPDF bookingID={bookingID} />
        
         
        </Modal.Body>
      </Modal>
      {/* Modal to add amount */}
      <Modal
        show={AddAmountData.modalShow}
        onHide={() => setAddAmountModal({
          resid: '',
          bookingid: '',
          amount: '',
          modalShow: false,
        })}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Payment for restaurant  
            <span style={{ color: 'red', marginLeft: '10px' }}>
              (Note: Remaining Amount {AddAmountData.amount})
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddAmount 
            handleAccountSubmit={handleRestaurnatPayment}
            setAddAmountModal={setAddAmountModal}
            AddAmountData={AddAmountData}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

ConfirmCard.propTypes = {
  bookingData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    agent_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    trip_uin: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    booking_details: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        day_name: PropTypes.string.isRequired,
        booking_date: PropTypes.string,
        status: PropTypes.string.isRequired,
        meal_name: PropTypes.string.isRequired,
        restaurant_name: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
        meal_offered: PropTypes.number.isRequired,
        total_meal: PropTypes.number.isRequired,
        total_amount: PropTypes.number.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  paxDetailsHandler: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
  setPaxDetailsHandler: PropTypes.func.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default ConfirmCard;
